function activateProductDescAccordion() {
    let accordions = document.getElementsByClassName("accordion-desc");
    let hasOpenedDefaultAccordion = false;
    var i = 0;
    while (i < accordions.length) {
            let acc = accordions[i];
            acc.children[0].addEventListener('click', () => toggleActive(acc));


            const isDefaultOpenDisabled = acc.dataset.defaultOpen === "false";

            if (isDefaultOpenDisabled) {
                    acc.classList.remove("active");
            } else if (!hasOpenedDefaultAccordion) {
                    acc.classList.add("active");
                    hasOpenedDefaultAccordion = true;
            } else {
                    acc.classList.remove("active");
            }

            i+=1;
      }
  }
  
  function toggleActive(element) {
      if (element.classList.contains("active")) {
              element.classList.remove("active");
      }
      else {
              element.classList.add("active")
      }
  }

  activateProductDescAccordion();
